import { useMemo } from "react";
import { SchedulerLesson } from "../../models/schedule/lesson";

function useSchedulerValidator<T extends SchedulerLesson>(
  lessons: T[][],
  displayLessons: T[][],
) {
  const isValid = useMemo(() => {
    const selectableLessons = lessons.flat().filter((l) => l.canActivate);

    return (
      selectableLessons.length === 0 ||
      selectableLessons.some((l) => l.isActive)
    );
  }, [lessons]);

  const hasNoActiveLessonsInDisplay = useMemo(
    () => displayLessons.flat().every((l) => !l.isActive && !l.canActivate),
    [displayLessons],
  );

  return { isValid, hasNoActiveLessonsInDisplay };
}

export default useSchedulerValidator;
